import { useViewport } from '@xyflow/react'
import React, { memo } from 'react'
import styled from 'styled-components'

import { useFlow } from '@/contexts/FlowContext'

import type { HelpLineHorizontalPosition, HelpLineVerticalPosition } from './types'

const SCxHorizontalHelpLine = styled.div`
    position: absolute;
    top: -1px;
    background-color: var(--color-main);
    z-index: 9;
    height: 1px;
`

const SCxVerticalHelpLine = styled.div`
    width: 1px;
    position: absolute;
    left: 1px;
    background-color: var(--color-main);
    z-index: 9;
`

const HelpLineHorizontal = memo(({ top, left, width }: HelpLineHorizontalPosition) => {
    const { x, y, zoom } = useViewport()

    return (
        <SCxHorizontalHelpLine
            className="SCxHorizontalHelpLine"
            style={{
                top: top * zoom + y,
                left: left * zoom + x,
                width: width * zoom
            }}
        />
    )
})
HelpLineHorizontal.displayName = 'HelpLineBase'

const HelpLineVertical = memo(({ top, left, height }: HelpLineVerticalPosition) => {
    const { x, y, zoom } = useViewport()

    return (
        <SCxVerticalHelpLine
            className="SCxVerticalHelpLine"
            style={{
                top: top * zoom + y,
                left: left * zoom + x,
                height: height * zoom
            }}
        />
    )
})
HelpLineVertical.displayName = 'HelpLineVertical'

const HelpLine = () => {
    const { helpLineHorizontal, helpLineVertical } = useFlow()
    if (!helpLineHorizontal && !helpLineVertical) {
        return null
    }

    return (
        <>
            {helpLineHorizontal && <HelpLineHorizontal {...helpLineHorizontal} />}
            {helpLineVertical && <HelpLineVertical {...helpLineVertical} />}
        </>
    )
}

export default memo(HelpLine)
